import { toCamelCase } from "../toCamelCase/toCamelCase"

type CamelCase<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
  ? `${Lowercase<P1>}${Uppercase<P2>}${CamelCase<P3>}`
  : Lowercase<S>

type DeepCamelCasedKeys<T> = T extends (infer U)[]
  ? DeepCamelCasedKeys<U>[]
  : T extends object
    ? {
        [K in keyof T as CamelCase<string & K>]: DeepCamelCasedKeys<T[K]>
      }
    : T

export const toCamelCasePropertiesDeep = <T>(obj: unknown): DeepCamelCasedKeys<T> => {
  if (Array.isArray(obj)) {
    return obj.map((item) => toCamelCasePropertiesDeep<unknown>(item)) as DeepCamelCasedKeys<T>
  }

  if (typeof obj !== "object" || obj === null) {
    return obj as DeepCamelCasedKeys<T>
  }

  return Object.entries(obj).reduce<Record<string, unknown>>((acc, [key, value]) => {
    const camelKey = toCamelCase(key)
    acc[camelKey] = toCamelCasePropertiesDeep<unknown>(value)
    return acc
  }, {}) as DeepCamelCasedKeys<T>
}
